export const blockIconsPlacesCorporateFare = (
	<span className='material-symbols-outlined'>corporate_fare</span>
);
